import { Switch } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import ActionTypes from  "../stateManagement/actions/types";
import { changeIsDeal } from '../stateManagement/actions/report';

const IsDealSwitch = () => {
    const dispatch = useDispatch();
    const {isDeal} = useSelector((state) => state.reportReducer);

    return (
            <Switch
                style={{margin: "1rem auto"}}
                checkedChildren="Private Deals only"
                unCheckedChildren="Private Deals only"
                onChange={(event)=>dispatch(changeIsDeal(event, ActionTypes.SWITCH_IS_DEAL))}
                checked={isDeal}
            />
    )
};

export default IsDealSwitch;